<template>
  <div>
    <div style="width: 1300px; margin: auto; display: flex">
      <div class="leftBox">
        <div class="innerBox">
          <div class="aboutUs">
            <div class="title_about_us" @click="goTo('AboutUs')">About us</div>
          </div>
          <div class="contactUs">
            <div class="title_contact_us" @click="goTo('ContactUs')">
              Contact us
            </div>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <div class="text">
          <h3>Comments and suggestions are welcomed!</h3>
          Address: No.159 Longpan Road, Nanjing, China
        </div>
        <BaiDuMap />
      </div>
    </div>

    </div>
</template>
  <script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "ContactUs",
  components: {  },
  data() {
    return {};
  },
  created() {},
  methods: {
    goTo(str) {
      this.$router.push({ name: str });
    },
  },
};
</script>
  <style scoped>
.text span.number {
  font-weight: bold; /* Make numbers bold */
  color: #007bff; /* A distinct blue color for numbers */
  font-size: 1.2em; /* Slightly larger size for numbers */
  background-color: #f0f0f0; /* A light gray background for numbers */
  padding: 2px 4px; /* Padding around the numbers */
  border-radius: 4px; /* Rounded corners for the background */
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2); /* Subtle shadow for depth */
}
.text {
  padding: 25px 0;
  font-weight: 500;
  font-family: "Times New Roman", Times, serif;
  color: #333; /* Dark gray color for the text */
  line-height: 2; /* Spacing between lines */
  font-size: 16px; /* Base font size */
  max-width: 750px; /* Maximum width of the text container */
  margin: 0 auto; /* Center the text container */
}
.leftBox {
  width: 310px;
  border-right: 1px solid #b8b8b8;
}
.rightBox {
  width: 990px;
}
.innerBox {
  width: 250px;
  height: 150px;
  margin: 50px 0 0 50px;
}

.aboutUs {
  height: 40px;
  background-color: white;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  padding-top: 13px;
  border: 1px solid #b8b8b8;
}
.aboutUs:hover {
  background-color: rgb(203, 225, 203);
}
.title_about_us {
  text-align: center;
  font-size: 20px;
}
.contactUs {
  height: 40px;
  background-color: rgb(203, 225, 203);
  border-radius: 0 0 10px 10px;
  cursor: pointer;
  border: 1px solid #b8b8b8;
  padding-top: 13px;
}
.contactUs:hover {
  background-color: rgb(203, 225, 203);
  transition: 0.3s;
}
.title_contact_us {
  text-align: center;
  font-size: 20px;
}
</style>